
// 1) TÄÄ KORJAA OUDON ONGELMAN: TUOTE-SKU:T ei päivittyneet joillain tuotteilla mutta nyt pitäisi päivittyä.

document.addEventListener('DOMContentLoaded', () => {
  // 1) Lue JSON:stä variantit
  const dataEl   = document.querySelector('script[data-product-json]');
  const variants = dataEl
    ? JSON.parse(dataEl.textContent).product.variants
    : [];

  // 2) Päivitä SKU-elementtiin
  function updateSku(variant) {
    const skuEl = document.querySelector('.product-meta__sku-number');
    if (skuEl && variant) skuEl.textContent = variant.sku;
  }

  // 3) Dawnin variantChange
  document.querySelectorAll('[data-section-type="product"]').forEach(section => {
    section.addEventListener('variantChange', e => {
      updateSku(e.detail.variant);
    });
  });

  // 4) Swatch‐radion click → find variant by option1 → aseta select → dispatch change
  document.querySelectorAll('.block-swatch__radio').forEach(radio => {
    radio.addEventListener('change', () => {
      // 4.1) haetaan swatchin orig‐value (oletusarvo josta loopissa annat orig-value=option1)
      const origVal = radio.getAttribute('value');
      // 4.2) etsitään se variant
      const v = variants.find(v => v.option1 === origVal);
      if (!v) return console.warn('Swatch → variant.id ei löydy:', origVal);

      // 4.3) asetetaan se Dawn‐selectin arvoksi
      const select = document.querySelector('select[name="id"]');
      if (select) {
        select.value = v.id;
        // 4.4) käynnistä Dawnin change‐flow
        select.dispatchEvent(new Event('change', { bubbles: true }));
        // 4.5) ja päivitys varmuudeksi suoraan
        updateSku(v);
      }
    });
  });
});
